import { Modify } from '@/types/helpers';
import { QuestionSettings } from '@/types/questionSettings';

export enum OptionType {
    OPTION = 'option',
    MARKUP = 'markup'
}

export type OptionConstructor = Partial<Option> & Pick<Option, 'id'>

export class Option {
    id: string;
    icon = null as string | null;
    color = null as string | null;
    alt = null as string | null;
    title = null as string | null;
    type = 'option' as OptionType;
    description = null as string | null;
    match = null as string | null;
    resetSession = false;
    externalLink = null as string | null;
    exclusive = false;
    focused = false;
    selectAllOption = false;

    constructor (option: OptionConstructor) {
        Object.assign(this, option || {});

        this.id = option.id;
    }
}

export type QuestionConstructor = Modify<Partial<Question> & Pick<Question, 'id' | 'type'>, {
    values?: OptionConstructor[];
}>

export class Question {
    filled = false
    formId = null as string | null;
    id: string;
    form = null as string | null;
    type: string;
    field: boolean;
    title = null as string | null;
    value = null as string | null;
    focused = false
    focusable: boolean;
    values?: Option[];
    stateId?: string;
    settings: QuestionSettings & Record<string, any>;
    data: any;

    constructor (question: QuestionConstructor) {
        Object.assign(this, question || {});

        this.id = question.id;
        this.field = question.field || !['title', 'message', 'redirectUrl'].includes(question.type);
        this.type = question.type;
        this.focusable = !['title', 'message', 'hidden', 'autoEmbeddingUrl', 'autoGeoLocation', 'redirectUrl'].includes(question.type) && this.field;
        this.filled = question.filled || ['hidden', 'autoEmbeddingUrl', 'autoGeoLocation', 'redirectUrl'].indexOf(question.type) !== -1;
        this.settings = new QuestionSettings(question.settings);
        this.values = question.values?.map(option => new Option(option)) || [];

        let debugPreset = document.cookie.match(new RegExp(`__odr-${this.type}.${this.id}=(\\'w-]+)`));
        if (debugPreset) {
            this.value = debugPreset[1];
        }
    }
};
